import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { App } from './pages/App';
import { Navbar } from './components/Navbar';

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <StrictMode>
    <Navbar />
    <App />
  </StrictMode>
);
